import { backendClient } from "../../api/backend";
import * as types from "./types";

const setLoading = (loading) => ({ type: types.INBOX_SET_LOADING, payload: loading });
const setError = (error) => ({ type: types.INBOX_SET_ERROR, payload: error });

export const fetchInboxThreads = (params = {}) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const data = await backendClient.getInboxThreads(params);
    dispatch({ type: types.INBOX_SET_THREADS, payload: data });
  } catch (e) {
    dispatch(setError(e.message));
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchInboxThread = (threadId) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const data = await backendClient.getInboxThread(threadId);
    dispatch({ type: types.INBOX_SET_CURRENT_THREAD, payload: data.thread });
    dispatch({ type: types.INBOX_SET_MESSAGES, payload: data.messages });
  } catch (e) {
    dispatch(setError(e.message));
  } finally {
    dispatch(setLoading(false));
  }
};

export const sendEmail = (data) => async () => {
  return await backendClient.sendInboxEmail(data);
};

export const sendEmailWithAttachments = (formData) => async () => {
  return await backendClient.sendInboxEmailWithAttachments(formData);
};

export const replyToThread = (threadId, data) => async (dispatch) => {
  const result = await backendClient.replyToThread(threadId, data);
  dispatch(fetchInboxThread(threadId));
  return result;
};

export const replyToThreadWithAttachments = (threadId, formData) => async (dispatch) => {
  const result = await backendClient.replyToThreadWithAttachments(threadId, formData);
  dispatch(fetchInboxThread(threadId));
  return result;
};

export const updateThread = (threadId, data) => async (dispatch) => {
  await backendClient.updateInboxThread(threadId, data);
};

export const fetchInboxStats = () => async (dispatch) => {
  try {
    const data = await backendClient.getInboxStats();
    dispatch({ type: types.INBOX_SET_STATS, payload: data });
  } catch (e) {
    console.error("Failed to fetch inbox stats:", e);
  }
};

export const fetchSignature = () => async (dispatch) => {
  try {
    const data = await backendClient.getSignature();
    dispatch({ type: types.INBOX_SET_SIGNATURE, payload: data });
  } catch (e) {
    console.error("Failed to fetch signature:", e);
  }
};

export const updateSignature = (data) => async (dispatch) => {
  const result = await backendClient.updateSignature(data);
  dispatch({ type: types.INBOX_SET_SIGNATURE, payload: result });
  return result;
};

export const suggestContacts = (query) => async (dispatch) => {
  const data = await backendClient.suggestInboxContacts(query);
  dispatch({ type: types.INBOX_SET_CONTACTS, payload: data });
  return data;
};

export const triggerSync = () => async (dispatch) => {
  const result = await backendClient.triggerInboxSync();
  dispatch(fetchInboxThreads());
  dispatch(fetchInboxStats());
  return result;
};
